export default class NumberRangeOptimizerModeEnum {
  static ORIGINAL = 'ORIGINAL';
  static NDC = 'NDC';
  static FULL = 'FULL';
  static OPTIMIZED = 'OPTIMIZED';
}
